module.exports = __webpack_public_path__ + "img/93970.deee8d82.svg";